import React from "react";

const PriceSummary = ({ employees, plan, t }) => {
  const pricePerEmployee = Number(plan?.price || 0);
  const total = Number(plan?.total || employees * pricePerEmployee);

  return (
    <div className="mb-6 rounded-xl bg-gray-100 p-4">
      <div className="mb-3 flex justify-between text-sm text-gray-500">
        <span>
          {t("pricing.calculator.currency")} {pricePerEmployee} × {employees}
        </span>

        <span>
          {t("pricing.calculator.currency")} {total}
        </span>
      </div>

      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs text-gray-500">
            {t("pricing.calculator.perEmployee")}
          </p>
          <p className="text-primary font-medium">
            {t("pricing.calculator.currency")} {pricePerEmployee}
          </p>
        </div>

        <div className="text-right">
          <p className="text-xs text-gray-500">
            {t("pricing.calculator.total")}
          </p>
          <p className="text-primary text-xl font-bold">
            {t("pricing.calculator.currency")} {total}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PriceSummary;
